import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  attendanceLoading: false,
  attendanceSuccess: false,
  attendanceError: false,
  attendanceMessage: null,
  attendanceData: null,

  attendanceGetLoading: false,
  attendanceGetSuccess: false,
  attendanceGetError: false,
  attendanceGetMessage: null,
  attendanceGetData: null,

  attTypeLoading: false,
  attTypeSuccess: false,
  attTypeError: false,
  attTypeMessage: null,
  attTypeData: null,
};

const user = JSON.parse(localStorage.getItem("user_data")) || {}
const userId = user?.user_id;
const accountType = user?.account_type;


// 

export const employeeAttType = createAsyncThunk(
  "employeeAttType",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            message: "No Internet Connection Found",
          };
          return data;
        } else {
          let data = {
            response: {
              data: {
                message: error.message,
              },
            },
          };
          return error;
        }
      });
  }
);

export const fetchAttendanceData = createAsyncThunk(
  "fetchAttendanceData",
  async (body) => {
    const { path, data } = body;
    return await axios
      .post(`${baseUrl}${path}`, data, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const saveAttendance = createAsyncThunk(
  "saveAttendance",
  async (body) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };

    const { path, data } = body;
    const url = baseUrl + path;

    return parseInt(accountType) === 2
      ? result
      : await axios
        .post(`${url}`, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (!navigator.onLine) {
            console.log(
              "You are offline. Please check your internet connection."
            );
          } else {
            console.log("An error occurred. Please try again later.", error);
          }
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        });
  }
);

const attendanceSlice = createSlice({
  name: "attendance",
  initialState,

  reducers: {
    initAttState: (state) => {
      state.attendanceLoading = false;
      state.attendanceSuccess = false;
      state.attendanceError = false;
      state.attendanceMessage = null;
    },
    initAttendanceState: (state) => {
      state.attendanceLoading = false;
      state.attendanceSuccess = false;
      state.attendanceError = false;
      state.attendanceMessage = null;
      state.attendanceData = null;

      state.attendanceGetLoading = false;
      state.attendanceGetSuccess = false;
      state.attendanceGetError = false;
      state.attendanceGetMessage = null;
    },

    initAttTypeState: (state) => {
      state.attTypeLoading = false;
      state.attTypeSuccess = false;
      state.attTypeError = false;
      state.attTypeMessage = null;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(fetchAttendanceData.pending, (state, action) => {
      state.attendanceGetLoading = true;
      state.attendanceGetSuccess = false;
      state.attendanceGetError = false;
      state.attendanceGetMessage = null;
      state.attendanceGetData = null;
    });
    builder.addCase(fetchAttendanceData.fulfilled, (state, action) => {
      state.attendanceGetLoading = false;
      state.attendanceGetSuccess = true;
      state.attendanceGetError = false;
      state.attendanceGetMessage = action.payload.data.message;
      state.attendanceGetData = action.payload.data;
    });
    builder.addCase(fetchAttendanceData.rejected, (state, action) => {
      state.attendanceGetLoading = false;
      state.attendanceGetSuccess = false;
      state.attendanceGetError = true;
      state.attendanceGetMessage = action.payload.data.message;
      state.attendanceGetData = null;
    });
    // To create attendance
    builder.addCase(saveAttendance.pending, (state, action) => {
      state.attendanceLoading = true;
      state.attendanceSuccess = false;
      state.attendanceError = false;
      state.attendanceMessage = null;
      state.attendanceData = null;
    });
    builder.addCase(saveAttendance.fulfilled, (state, action) => {
      if (action.payload.status == 200) {
        let status = action.payload.data.status;
        if (status) {
          state.attendanceLoading = false;
          state.attendanceSuccess = accountType == 2 ? false : true;
          state.attendanceError = accountType == 2 ? true : false;
          state.attendanceMessage = action.payload.data.message;
          state.attendanceData = action.payload.data;
        } else {
          console.log(action.payload);
          state.attendanceLoading = false;
          state.attendanceSuccess =
            accountType == 2 ? false : status ? true : false;
          state.attendanceError =
            accountType == 2 ? true : status ? false : true;
          state.attendanceMessage = action.payload.data.message;
          state.attendanceData = null;
        }
      } else {
        state.attendanceLoading = false;
        state.attendanceSuccess = false;
        state.attendanceError = true;
        state.attendanceMessage = action.payload.response.message;
        state.attendanceData = null;
      }
    });
    builder.addCase(saveAttendance.rejected, (state, action) => {
      state.attendanceLoading = false;
      state.attendanceSuccess = false;
      state.attendanceError = true;
      state.attendanceMessage = "message";
      state.attendanceData = null;
    });

    // To get attendance type
    builder.addCase(employeeAttType.pending, (state, action) => {
      state.attTypeLoading = true;
      state.attTypeSuccess = false;
      state.attTypeError = false;
      state.attTypeMessage = null;
      state.attTypeData = null;
    });
    builder.addCase(employeeAttType.fulfilled, (state, action) => {
      if (action.payload.status == 200) {
        let status = action.payload.data.status;
        if (status) {
          state.attTypeLoading = false;
          state.attTypeSuccess = accountType == 2 ? false : true;
          state.attTypeError = accountType == 2 ? true : false;
          state.attTypeMessage = action.payload.data.message;
          state.attTypeData = action.payload.data;
        } else {
          console.log(action.payload);
          state.attTypeLoading = false;
          state.attTypeSuccess =
            accountType == 2 ? false : status ? true : false;
          state.attTypeError =
            accountType == 2 ? true : status ? false : true;
          state.attTypeMessage = action.payload.data.message;
          state.attTypeData = null;
        }
      } else {
        state.attTypeLoading = false;
        state.attTypeSuccess = false;
        state.attTypeError = true;
        state.attTypeMessage = action.payload.response.message;
        state.attTypeData = null;
      }
    });
    builder.addCase(employeeAttType.rejected, (state, action) => {
      state.attTypeLoading = false;
      state.attTypeSuccess = false;
      state.attTypeError = true;
      state.attTypeMessage = "message";
      state.attTypeData = null;
    });
  },
});

export const { initAttState, initAttendanceState, initAttTypeState } = attendanceSlice.actions;

export default attendanceSlice.reducer;
